export const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
